import { Method } from 'axios';
import { Executable } from './executable';
import { Order } from './get-tokens';

/**
 * The GetOrdersInput used by the constructor of GetOrders
 */
export interface GetOrdersInput {
  /**
   * The orderId to retrieve a specific order.
   */
  orderId?: number;
  /**
   * The bambu personId for identifying a person.
   */
  personId?: string;
  /**
   * The email address of the person.
   */
  email?: string;
}

/**
 * The GetOrders response expected from the execution of the object within BambuClient execute.
 */
export interface GetOrdersResponse {
  /**
   * the message response from the request
   */
  orders: Order[];
  /**
   * any error messages that were returned by the request.
   */
  error?: any;
}

/**
 * The get order api is a retrieves the list of orders created for the provided person.
 */
export class GetOrders extends Executable<GetOrdersResponse> {
  public orderId?: number;

  public personId?: string;

  public email?: string;

  /**
   * getMethod is used by the BambuClient to properly construct the request call.
   * @returns request method
   */
  public getMethod(): Method {
    return 'get';
  }

  /**
   * getResponse is used by the BambuClient to propery return the response object type.
   * @param apiResponse the api response object returned by the BambuMeta client before being converted to the GetOrderResponse
   * @returns GetOrderResponse
   */
  public getResponse(apiResponse: any): GetOrdersResponse {
    return {
      orders: apiResponse,
    };
  }

  /**
   * getURLPath is used by the BambuClient to properly construct the request call.
   * @param tenantId the tenant id defined in the BambuClient
   * @returns request url
   */
  public getURLPath(tenantId?: string): string {
    let url = `${tenantId}/orders`;
    if (this.orderId) {
      url += `?order_id=${this.orderId}`;
    } else if (this.personId) {
      url += `?person_id=${this.personId}`;
    } else if (this.email) {
      url += `?email=${this.email}`;
    }
    return url;
  }

  constructor(input?: GetOrdersInput) {
    super();
    if (input) {
      Object.assign(this, input);
    }
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): any {
    return undefined;
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return undefined;
  }
}
